import { WithholdingConfiguration } from "./withholding-configuration";

export class WithholdingGroup {

    id: number = 0;
    description!: string;
    withholdingConfigurations: WithholdingConfiguration [] = [];

}